/** Batch #14.309 — valeurs à recopier dans le formulaire « production » de l'app Intuit (developer.intuit.com). */
import { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, Copy } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";

const ROWS = [["host_domain", "Host domain"], ["launch_url", "Launch URL"], ["disconnect_url", "Disconnect URL"], ["connect_url", "Connect/Reconnect URL"],
  ["eula_url", "End-user license agreement URL"], ["privacy_url", "Privacy policy URL"], ["redirect_uri", "Redirect URI (Keys & credentials)"]];

export default function IntuitFormInfo() {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);
  useEffect(() => { if (open && !info) api.get("/qbo/config").then((r) => setInfo(r.data.intuit_form)).catch(() => setInfo({})); }, [open, info]);
  const copy = (v) => { navigator.clipboard?.writeText(v); toast.success("Copié"); };
  const Chev = open ? ChevronDown : ChevronRight;
  return (
    <div className="text-[11px]">
      <button type="button" onClick={() => setOpen((v) => !v)} className="inline-flex items-center gap-1 text-slate-500 hover:text-slate-800" data-testid="qbo-intuit-form-toggle"><Chev className="w-3 h-3" /> Infos pour le formulaire Intuit (passage en production)</button>
      {open && info && (
        <table className="mt-2 w-full border-separate border-spacing-y-1" data-testid="qbo-intuit-form">
          <tbody>
            {ROWS.map(([k, label]) => (
              <tr key={k}>
                <td className="pr-3 text-slate-500 whitespace-nowrap align-top">{label}</td>
                <td className="font-mono text-slate-800 break-all" data-testid={`qbo-intuit-${k}`}>{info[k] || "—"}</td>
                <td className="pl-2 align-top"><button type="button" onClick={() => copy(info[k] || "")} className="text-slate-400 hover:text-slate-800" title="Copier" data-testid={`qbo-intuit-copy-${k}`}><Copy className="w-3 h-3" /></button></td>
              </tr>
            ))}
            <tr><td className="pr-3 text-slate-500 whitespace-nowrap">Hébergement</td><td className="text-slate-800" colSpan={2}>Canada — aucune adresse IP fixe : laisser le champ IP vide</td></tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
